import { ChangeEvent } from "react";
import {
  buttonLanguageVariant,
  formLanguage,
  inputLanguage,
} from "./styles.css";
import { useLanguage } from "../../../../providers/language/context";
import { Language } from "../../../../providers/language/types";

export const ChangeLanguageButtons = () => {
  const { language, changeLanguage } = useLanguage();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    changeLanguage(e.target!.value as Language);
  };

  return (
    <form name="form-language" className={formLanguage}>
      <label
        className={
          language === "en"
            ? buttonLanguageVariant.active
            : buttonLanguageVariant.passive
        }
      >
        En
        <input
          type="radio"
          name="input-language"
          value="en"
          className={inputLanguage}
          onChange={handleChange}
          checked={language === "en"}
        />
      </label>
      <label
        className={
          language === "de"
            ? buttonLanguageVariant.active
            : buttonLanguageVariant.passive
        }
      >
        De
        <input
          type="radio"
          name="input-language"
          value="de"
          className={inputLanguage}
          onChange={handleChange}
          checked={language === "de"}
        />
      </label>
    </form>
  );
};
